import React, { createContext, useContext, useState, useCallback } from "react";

/**
 * Tiny live-call context. The IncomingCallPopup ("Answer") sets the active
 * call here, then the global LiveCallWidget mounts to track it. The
 * Customer 360 panel reads the same context to show a live tab.
 */
const LiveCallCtx = createContext(null);

export const LiveCallProvider = ({ children }) => {
  const [activeCall, setActiveCall] = useState(null);

  const startCall = useCallback((call) => setActiveCall(call), []);
  const endCall = useCallback(() => setActiveCall(null), []);

  const value = { activeCall, startCall, endCall };
  return <LiveCallCtx.Provider value={value}>{children}</LiveCallCtx.Provider>;
};

export const useLiveCall = () => {
  const ctx = useContext(LiveCallCtx);
  if (!ctx) {
    throw new Error("useLiveCall must be used inside <LiveCallProvider>");
  }
  return ctx;
};
